import Vue from 'vue'
import VueRouter from 'vue-router'
import layoutIndex from "@/components/layoutIndex";

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: layoutIndex,
    children: [
      {
        path: '',
        component: () => import('@/pages/home/index.vue'),
        name: '首页',
        meta: {
          name: 'home'
        }
      },
      {
        path: 'companyIntroduction',
        component: () => import('@/pages/companyIntroduction/index.vue'),
        name: '公司介绍',
        meta: {
          name: 'companyIntroduction'
        }
      },
      {
        path: 'developmentHistory',
        component: () => import('@/pages/companyIntroduction/developmentHistory.vue'),
        name: '发展历程',
        meta: {
          name: 'developmentHistory'
        }
      },
      {
        path: 'warehouse',
        component: () => import('@/pages/companyIntroduction/warehouse.vue'),
        name: '自有仓库',
        meta: {
          name: 'warehouse'
        }
      },
      {
        path: 'dominantIndustry',
        component: () => import('@/pages/dominantIndustry/index.vue'),
        name: '主营产品',
        meta: {
          name: 'dominantIndustry'
        }
      },
      {
        path: 'coBranding',
        component: () => import('@/pages/coBranding/index.vue'),
        name: '合作品牌',
        meta: {
          name: 'coBranding'
        }
      },
      {
        path: 'notice',
        component: () => import('@/pages/notice/index.vue'),
        name: '动态通告',
        meta: {
          name: 'notice'
        }
      },
      {
        path: 'noticeDetail',
        component: () => import('@/pages/notice/detail.vue'),
        name: '动态通告详情',
        meta: {
          name: 'noticeDetail'
        }
      },
      {
        path: 'contactUs',
        component: () => import('@/pages/contactUs/index.vue'),
        name: '联系我们',
        meta: {
          name: 'contactUs'
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router